import { motion } from "framer-motion";
import DecodeText from "./DecodeText";
import HudLabel from "./HudLabel";
import "./Skills.css";

// Signature move: cards flip in on the Y axis like a rack of HUD panels
// snapping into place, one after another.
const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.1 } },
};
const card = {
  hidden: { opacity: 0, rotateY: -85, y: 34, transformPerspective: 900 },
  show: {
    opacity: 1,
    rotateY: 0,
    y: 0,
    transformPerspective: 900,
    transition: { duration: 0.6, ease: [0.2, 0.75, 0.2, 1] },
  },
};

/** Skills grouped into HUD "suit-tech" style cards. */
export default function Skills({ skills }) {
  return (
    <section id="skills" className="section skills">
      <HudLabel className="skills__eyebrow" text="LOADOUT" />
      <DecodeText as="h2" className="skills__title hud-title" text="Skills" />

      <motion.div
        className="skills__grid"
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {skills.map((group) => (
          <motion.div
            key={group.group}
            className="skills__card hud-panel hud-panel--full"
            variants={card}
          >
            <span className="hud-corner-tr" aria-hidden="true" />
            <span className="hud-corner-bl" aria-hidden="true" />
            <h3 className="skills__group">{group.group}</h3>
            <div className="skills__items">
              {group.items.map((item) => (
                <span key={item} className="skills__chip">
                  {item}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
